import { isInternalPath } from '@/shared/lib/pendingIntentStorage'

/** Caminho interno do atalho aberto, ou null para abertura normal ou URL de fora. */
export function launchTargetPath(targetURL: string | undefined, origin: string): string | null {
  if (!targetURL) return null
  try {
    const url = new URL(targetURL)
    if (url.origin !== origin) return null
    const path = `${url.pathname}${url.search}${url.hash}`
    return isInternalPath(path) ? path : null
  } catch {
    return null
  }
}
